module.exports = __webpack_public_path__ + "static/kabuhayan-cafe-logo-89f173c3a49df23208a590371b4593a7.png";